<template>
  <landing-page
    label="factSheet.hazardsOfSmoking"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'factsheet', imgName: 'hazardsOfSmokingLandingImage', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
  />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div>
      <div v-html="t('factSheet.hazardsOfSmokingDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.whoFinds") }}</div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.hazardsOfSmokingWhoFindsList" :key="'hazardsOfSmokingWhoFinds' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.getFromTobaccoSmoking") }}</div>
      <div v-html="t('factSheet.getFromTobaccoSmokingDesc')" class="space-y-5" />
    </div>

    <div class="font-bold text-description">{{ t("factSheet.magorIngrediantsCigaretts") }}</div>

    <div class="space-y-12">
      <div v-for="(item, index) in factSheetStore.hazardsOfSmokingMajorIngrediantsList" :key="'hazardsOfSmokingMajorIngrediants' + index">
        <span class="font-bold text-description">{{ t(item.label) }}</span>
        <span v-html="t(item.desc)" class="space-y-5" />
      </div>
    </div>

    <div class="text-description">{{ t("factSheet.majorIngrediantsCigareetsDesc") }}</div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.methodOfQuitting") }}</div>
      <div class="text-description">{{ t("factSheet.methodOfQuittingDesc") }}</div>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.preparationBeforeQuitting") }}</div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.hazardsOfSmokingPreparationList" :key="'hazardsOfSmokingPreparation' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.beginningFromQuitDay") }}</div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.hazardsOfSmokingQuitDayList" :key="'hazardsOfSmokingQuitDay' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.medicationsQuittingSmoking") }}</div>
      <div v-html="t('factSheet.medicationsQuittingSmokingDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.counsellingOnQuittingSmoking") }}</div>
      <div v-html="t('factSheet.counsellingOnQuittingSmokingDesc')" class="space-y-5" />
    </div>

    <div>
      <div v-html="t('factSheet.smokingCessationClinic')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.quitSmoking") }}</div>
      <div v-html="t('factSheet.quitSmokingDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.balancedDiet2") }}</div>
      <div v-html="t('factSheet.balancedDiet2Desc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.adequateExercise") }}</div>
      <div v-html="t('factSheet.adequateExerciseDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.mentalHealth") }}</div>
      <div v-html="t('factSheet.mentalHealthDesc')" class="space-y-5" />
    </div>

    <div>
      <div v-html="t('factSheet.optimisticPositiveAttitude')" class="space-y-5" />
    </div>

    <div v-html="t('factSheet.hazardsOfSmokingRef')" class="mt-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.hazardsOfSmoking") }}</div>
      </div>
      <div>
        <div v-html="t('factSheetChinese.hazardsOfSmokingDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.whoFinds") }}</div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.hazardsOfSmokingWhoFindsList" :key="'hazardsOfSmokingWhoFinds' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.getFromTobaccoSmoking") }}</div>
        <div v-html="t('factSheetChinese.getFromTobaccoSmokingDesc')" class="space-y-5" />
      </div>

      <div class="font-bold text-description">{{ t("factSheetChinese.magorIngrediantsCigaretts") }}</div>

      <div class="space-y-12">
        <div v-for="(item, index) in factSheetStore.hazardsOfSmokingMajorIngrediantsList" :key="'hazardsOfSmokingMajorIngrediants' + index">
          <span class="font-bold text-description">{{ t(item.label.replace("factSheet", "factSheetChinese")) }}</span>
          <span v-html="t(item.desc.replace('factSheet', 'factSheetChinese'))" class="space-y-5" />
        </div>
      </div>

      <div class="text-description">{{ t("factSheetChinese.majorIngrediantsCigareetsDesc") }}</div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.methodOfQuitting") }}</div>
        <div class="text-description">{{ t("factSheetChinese.methodOfQuittingDesc") }}</div>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.preparationBeforeQuitting") }}</div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.hazardsOfSmokingPreparationList" :key="'hazardsOfSmokingPreparation' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.beginningFromQuitDay") }}</div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.hazardsOfSmokingQuitDayList" :key="'hazardsOfSmokingQuitDay' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.medicationsQuittingSmoking") }}</div>
        <div v-html="t('factSheetChinese.medicationsQuittingSmokingDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.counsellingOnQuittingSmoking") }}</div>
        <div v-html="t('factSheetChinese.counsellingOnQuittingSmokingDesc')" class="space-y-5" />
      </div>

      <div>
        <div v-html="t('factSheetChinese.smokingCessationClinic')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.quitSmoking") }}</div>
        <div v-html="t('factSheetChinese.quitSmokingDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.balancedDiet2") }}</div>
        <div v-html="t('factSheetChinese.balancedDiet2Desc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.adequateExercise") }}</div>
        <div v-html="t('factSheetChinese.adequateExerciseDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.mentalHealth") }}</div>
        <div v-html="t('factSheetChinese.mentalHealthDesc')" class="space-y-5" />
      </div>

      <div>
        <div v-html="t('factSheetChinese.optimisticPositiveAttitude')" class="space-y-5" />
      </div>

      <div v-html="t('factSheetChinese.hazardsOfSmokingRef')" class="mt-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>